import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';

import { negocio } from 'Infotrack@Modelos/conexiones';
import IFamilia from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IFamilia';

class ModeloFamilia {
    private NOMBRE_CONTROLADOR = 'Familia';

    public async consultarListaFamilia() {
        return manejadorRest<IRespuesta<IFamilia>>(
            () => negocio.get(`${this.NOMBRE_CONTROLADOR}/ConsultarListaFamilia`),
            true
        );
    }

    public crearFamilias(familia: IFamilia) {
        return manejadorRest<IRespuesta<IFamilia>>(
            () => negocio.post(`${this.NOMBRE_CONTROLADOR}/GuardarFamilia`, familia),
            true
        );
    }

    public editarFamilias(familia: IFamilia) {
        return manejadorRest<IRespuesta<IFamilia>>(
            () => negocio.put(`${this.NOMBRE_CONTROLADOR}/EditarFamilia`, familia),
            true
        );
    }

    public eliminarFamilias(familia: IFamilia) {
        return manejadorRest<IRespuesta<IFamilia>>(
            () => negocio.delete(`${this.NOMBRE_CONTROLADOR}/EliminarFamilia`, familia),
            true
        );
    }

    public consultarListaFamiliasPorFiltro(familia: Partial<IFamilia>) {
        return manejadorRest<IRespuesta<IFamilia>>(
            () => negocio.post(`${this.NOMBRE_CONTROLADOR}/ConsultarListaFiltro`, familia),
            true
        );
    }
}

export default ModeloFamilia;
